import { render, staticRenderFns } from "./ListSectors.vue?vue&type=template&id=5373aaa9&scoped=true"
import script from "./ListSectors.vue?vue&type=script&lang=js"
export * from "./ListSectors.vue?vue&type=script&lang=js"
import style0 from "./ListSectors.vue?vue&type=style&index=0&id=5373aaa9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5373aaa9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5373aaa9')) {
      api.createRecord('5373aaa9', component.options)
    } else {
      api.reload('5373aaa9', component.options)
    }
    module.hot.accept("./ListSectors.vue?vue&type=template&id=5373aaa9&scoped=true", function () {
      api.rerender('5373aaa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/List/ListSectors.vue"
export default component.exports